import type { Layer } from '../../../context/context';
import type { Fleet } from '../components/FleetMenu';

export function isPlaceholderFleet(fleet: Fleet): boolean {
  return fleet.vehicles.length === 0 && (fleet.id === 'fleet-1' || fleet.name === 'Fleet 1');
}

export function upsertWizardFleetList(
  previousFleets: Fleet[],
  incomingFleet: Fleet
): { fleets: Fleet[]; resolvedFleetId: string } {
  const placeholderIndex = previousFleets.findIndex(isPlaceholderFleet);
  if (placeholderIndex >= 0) {
    const preservedId = previousFleets[placeholderIndex].id;
    const next = [...previousFleets];
    next[placeholderIndex] = {
      ...incomingFleet,
      id: preservedId,
    };
    return {
      fleets: next,
      resolvedFleetId: preservedId,
    };
  }

  return {
    fleets: [...previousFleets, incomingFleet],
    resolvedFleetId: incomingFleet.id,
  };
}

export function resolveWizardTripLayerTarget(
  previousLayers: Layer[],
  recentRideLayerId: string | null | undefined
): { nextLayerId: number; reusableLayer: Layer | null } {
  const parsedRecentLayerId = Number(recentRideLayerId);
  const hasReusableId = Number.isFinite(parsedRecentLayerId) && parsedRecentLayerId >= 0;

  const reusableLayer = hasReusableId
    ? previousLayers.find((layer) => layer.layerId === parsedRecentLayerId) ?? null
    : null;

  if (reusableLayer) {
    return {
      nextLayerId: reusableLayer.layerId,
      reusableLayer,
    };
  }

  const existingLayerIds = previousLayers
    .map((layer) => layer.layerId)
    .filter((id): id is number => id !== undefined && id !== null);

  return {
    nextLayerId: existingLayerIds.length > 0 ? Math.max(...existingLayerIds) + 1 : 0,
    reusableLayer: null,
  };
}
